import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
The main entry point for the Submit Review page.

Referenced by the page.submit-review.liquid template.
* */
import React from 'react';
import ReactDOM from 'react-dom';
import './scss/templates/page-submit-review.scss';
import OVApp from './utils/OVContext';
import SubmitAReview from './components/SubmitAReview';
import { jsx as _jsx } from "react/jsx-runtime";

var do404 = function do404() {
  console.info('not found');
  window.location.assign('/404');
};

var initSubmitAReview = function initSubmitAReview() {
  var search = window.location.search;
  var urlParams = new URLSearchParams(search);
  var shopifyId = urlParams.get('product_id');
  var variantId = urlParams.get('variant');
  var rootEl = document.getElementById('submit-review');

  if (shopifyId === null) {
    do404();
    return;
  }

  var props = {
    shopifyId: shopifyId,
    loadingHTML: rootEl.innerHTML
  };

  if (variantId) {
    props.variantId = variantId;
  }

  ReactDOM.render( /*#__PURE__*/_jsx(OVApp, {
    children: /*#__PURE__*/_jsx(SubmitAReview, _objectSpread({}, props))
  }), rootEl);
};

initSubmitAReview();